"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tag_1 = __importDefault(require("./Tag"));
const utils_1 = require("./utils");
const Banner = props => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderPointsBanner(props),
        renderCirclesBanner(props),
        renderRectanglesBanner(props),
        renderPolylinesBanner(props),
        renderPolygonsBanner(props)));
};
const renderPointsBanner = (props) => {
    const { points, pointRemoval } = props;
    if (!points)
        return null;
    const onRemove = pointRemoval
        ? (removePoint) => () => {
            pointRemoval(removePoint);
        }
        : () => undefined;
    const pointTags = points.map((point, i) => {
        return generateTag(utils_1.stringifyPoint(point), i, onRemove(point));
    });
    return constructBanner("Points", pointTags);
};
const renderCirclesBanner = (props) => {
    const { circles, circleRemoval } = props;
    if (!circles)
        return null;
    const onRemove = circleRemoval
        ? (removeCircle) => () => {
            circleRemoval(removeCircle);
        }
        : () => undefined;
    const circleTags = circles.map((circle, i) => {
        return generateTag(utils_1.stringifyCircle(circle), i, onRemove(circle));
    });
    return constructBanner("Circles", circleTags);
};
const renderRectanglesBanner = (props) => {
    const { rectangles, rectangleRemoval } = props;
    if (!rectangles)
        return null;
    const onRemove = rectangleRemoval
        ? (removeRectangle) => () => {
            rectangleRemoval(removeRectangle);
        }
        : () => undefined;
    const rectangleTags = rectangles.map((rectangle, i) => {
        return generateTag(utils_1.stringifyRectangle(rectangle), i, onRemove(rectangle));
    });
    return constructBanner("Rectangles", rectangleTags);
};
const renderPolylinesBanner = (props) => {
    const { polylines, polylineRemoval } = props;
    if (!polylines)
        return null;
    const onRemove = polylineRemoval
        ? (removePolyline) => () => {
            polylineRemoval(removePolyline);
        }
        : () => undefined;
    const polylineTags = polylines.map((polyline, i) => {
        return generateTag(utils_1.stringifyPointSeries(polyline), i, onRemove(polyline));
    });
    return constructBanner("Lines", polylineTags);
};
const renderPolygonsBanner = (props) => {
    const { polygons, polygonRemoval } = props;
    if (!polygons)
        return null;
    const onRemove = polygonRemoval
        ? (removePolygon) => () => {
            polygonRemoval(removePolygon);
        }
        : () => undefined;
    const polygonTags = polygons.map((polygon, i) => {
        return generateTag(utils_1.stringifyPointSeries(polygon), i, onRemove(polygon));
    });
    return constructBanner("Polygons", polygonTags);
};
const generateTag = (value, i, onRemove) => {
    return react_1.default.createElement(Tag_1.default, { content: value, onRemove: onRemove, key: value + i });
};
const constructBanner = (bannerName, tags) => {
    return (react_1.default.createElement("div", { className: "flex-container flex-wrap some-margin" },
        react_1.default.createElement("h3", { className: "text no-margin" },
            bannerName,
            ": "),
        tags));
};
exports.default = Banner;
